import AppBar from '@mui/material/AppBar';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link, useLocation } from 'react-router-dom'
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { CardMedia, CardActionArea, Card } from '@mui/material';
import { Auth } from 'aws-amplify';
import { StyledEngineProvider } from '@mui/material/styles';
import "./Header.css";
import { ComponentAccess } from '../../components/componentAccess/ComponentAccess';
import { rolesMap } from '../../constants/roles-constants';
import NotificationBell, { Notification } from './NotificationBell';
import { getActiveCampaignsData } from '../../pages/ListCampaigns/services/api-calls';
import { useState, useEffect } from 'react';
import { getCampaignQueryParams } from '../../utils/rolesUtils';
import { getCampaignNotifications } from '../../utils/notificationUtils';

type HeaderProps = {
    auth: CognitoUser | null;
    notifications?: Notification[];
}

export interface CognitoUser {
    [key: string]: any
}

export interface ButtonState {
    [key: string]: any
}

export default function ButtonAppBar({ auth }: HeaderProps) {
    const location = useLocation();

    const getToggleOnButton = (path: string) => {
        return location.pathname === path ? 'toggledOn' : '';
    };

    const handleSignOut = async () => {
        try {
            await Auth.signOut({ global: true });
        } catch (error) {
            console.warn('Global sign-out issue:', error);
        } finally {
            // Always ensure local logout & UI reset
            try {
                await Auth.signOut();
            } catch (error) {
                console.warn(error);
            }
        }
    };

    const promotionId = location.pathname.replace(/^.*\/(.*)$/, "$1");
    const isAssignedPromotionPage = location.pathname.includes('assignPromotion');
    const [notifications, setNotifications] = useState<Notification[]>([]);
    const loggedInUser = auth?.email;
    useEffect(() => {
        const params = getCampaignQueryParams();

        getActiveCampaignsData(params)
            .then((campaigns) => {
                setNotifications(getCampaignNotifications(campaigns, loggedInUser));
            })
            .catch((err) => console.error('Error loading notifications', err));
    }, [loggedInUser]);

    return (
        <StyledEngineProvider injectFirst>
            <Box>
                <AppBar className='headerWrapper'>
                    <Toolbar>
                        <Box className='profileSection'>
                            <Card className='cardMedia'>
                                <CardActionArea
                                    component={Link}
                                    to='/'
                                >
                                    <CardMedia
                                        className='profileIcon'
                                        component="img"
                                        image="/promo-plus-logo.svg"
                                        alt="Promo+ logo"
                                    />
                                </CardActionArea>
                            </Card>
                            {!isAssignedPromotionPage &&
                                <>
                                    <Button component={Link} to="/" className={`headerButton ${getToggleOnButton('/')}`}>
                                        HOME
                                    </Button>

                                    <Button component={Link} to="/listCampaigns" className={`headerButton ${getToggleOnButton('/listCampaigns')}`}>
                                        CAMPAIGNS
                                    </Button>

                                    <Button
                                        component={Link}
                                        to="/listCurrencies"
                                        className={`headerButton ${getToggleOnButton('/listCurrencies')}`}>
                                        CURRENCIES
                                    </Button>
                                    <ComponentAccess minRole={rolesMap.SuperAdmin}>
                                        <Button
                                            component={Link}
                                            to="/adminPanel"
                                            className={`headerButton ${getToggleOnButton('/adminPanel')}`}>
                                            ADMIN PANEL
                                        </Button>
                                    </ComponentAccess>
                                    <ComponentAccess minRole={rolesMap.PrizeManager}>
                                        <Button
                                            component={Link}
                                            to="/receiptScanner"
                                            className={`headerButton ${getToggleOnButton('/receiptScanner')}`}>
                                            RECEIPT SCANNER
                                        </Button>
                                    </ComponentAccess>
                                </>
                            }
                            {isAssignedPromotionPage &&
                                <Button component={Link} to={`/editCampaign/${promotionId}`} className={`headerButton ${getToggleOnButton(`/editCampaign/${promotionId}`)}`}>
                                    Back to Campaign
                                </Button>
                            }
                        </Box>
                        {auth &&
                            <Box display='flex' alignItems='center' gap={0} marginLeft='auto'>
                                <NotificationBell notifications={notifications} />
                                <Button className='profileButton'><AccountCircleIcon />{auth.email}</Button>
                                <Button className='profileButton' onClick={async () => await handleSignOut()}><LogoutIcon />Logout</Button>
                            </Box>
                        }
                    </Toolbar>
                </AppBar>
            </Box>
        </StyledEngineProvider>
    );
}
